import styles from "./NotFound.module.css"

const NotFound = () => {
  return <h1 className={styles.heading}>Page not found</h1>
}

export default NotFound
